export function validateCEP(cep?: string): boolean {
  if (!cep) return false
  const cepRegex = /^[0-9]{5}-?[0-9]{3}$/
  return cepRegex.test(cep)
}
